// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.casesList .case {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0px;
}
.casesList .case .caseInfo {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  flex-wrap: wrap;
}
.casesList .case .caseInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/casesList/casesList.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAFR;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAFV;AAGU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADZ","sourcesContent":["@import \"../../style.scss\";\n\n.casesList{\n    .case {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin: 20px 0px;\n\n        .caseInfo {\n          display: flex;\n          align-items: center;\n          gap: 20px;\n          position: relative;\n          flex-wrap: wrap;\n          img {\n            width: 40px;\n            height: 40px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
